"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var asyncFunctionConstructor_1 = require("./utils/asyncFunctionConstructor");
var description_1 = require("./utils/description");
/**
 * Checks whether value is async function.
 * Only functions created with modifier "async" are considered async.
 * Regular function that returns promise or accepts callback is not an async function.
 *
 * More info: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AsyncFunction
 *
 * @example
 * is.asyncFunction(async () => {}); // true
 * is.asyncFunction(function* () {}); // false
 * is.asyncFunction(function() {}); // false
 */
function isAsyncFunction(value) {
    return !!asyncFunctionConstructor_1.asyncFunctionConstructor && value instanceof asyncFunctionConstructor_1.asyncFunctionConstructor;
}
exports.default = isAsyncFunction;
description_1.setDescription(isAsyncFunction, 'an async function');
